import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { tokens } from '../../../../lib/src/theme/design-tokens';

// Maps DESIGN.md tokens onto PrimeNG's Aura preset.
// The vivid primary green comes from `tokens.colors.primary`. Surface and
// border colors come from the neutral stack defined in DESIGN.md. Border
// radius matches the `md` token so PrimeNG controls (buttons, inputs,
// dropdowns) inherit the same shape language as Tailwind utilities.
export const ButacoPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  tokens.colors['primary-soft'],
      100: tokens.colors['primary-soft'],
      200: tokens.colors['primary-soft'],
      300: '{green.300}',
      400: '{green.400}',
      500: tokens.colors.primary,
      600: tokens.colors.primary,
      700: tokens.colors['primary-hover'],
      800: tokens.colors['primary-hover'],
      900: '{green.900}',
      950: '{green.950}',
    },
    borderRadius: {
      none: '0',
      xs:   tokens.rounded.sm,
      sm:   tokens.rounded.sm,
      md:   tokens.rounded.md,
      lg:   tokens.rounded.lg,
      xl:   tokens.rounded.lg,
    },
    colorScheme: {
      light: {
        primary: {
          color:        tokens.colors.primary,
          inverseColor: tokens.colors['on-primary'],
          hoverColor:   tokens.colors['primary-hover'],
          activeColor:  tokens.colors['primary-hover'],
        },
        surface: {
          0:   tokens.colors.surface,
          50:  tokens.colors['surface-muted'],
          100: tokens.colors['surface-sunken'],
          200: tokens.colors.border,
          300: tokens.colors['border-strong'],
          400: tokens.colors['text-subtle'],
          500: tokens.colors['text-muted'],
          600: tokens.colors['text-muted'],
          700: tokens.colors.text,
          800: tokens.colors.text,
          900: tokens.colors.text,
          950: tokens.colors.text,
        },
        formField: {
          background:       tokens.colors.surface,
          borderColor:      tokens.colors.border,
          hoverBorderColor: tokens.colors['border-strong'],
          focusBorderColor: tokens.colors.primary,
          color:            tokens.colors.text,
          placeholderColor: tokens.colors['text-subtle'],
        },
        content: {
          background:        tokens.colors.surface,
          hoverBackground:   tokens.colors['surface-muted'],
          borderColor:       tokens.colors.border,
          color:             tokens.colors.text,
          hoverColor:        tokens.colors.text,
        },
        text: {
          color:           tokens.colors.text,
          hoverColor:      tokens.colors.text,
          mutedColor:      tokens.colors['text-muted'],
          hoverMutedColor: tokens.colors.text,
        },
      },
    },
  },
});
